var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTadaLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.5,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 17.9375C19.75 17.5578 20.0578 17.25 20.4375 17.25H21.8125C22.1922 17.25 22.5 17.5578 22.5 17.9375V19.3125C22.5 19.6922 22.1922 20 21.8125 20H20.4375C20.0578 20 19.75 19.6922 19.75 19.3125V17.9375Z",
    fill: "#E1CE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.875 17.9375C23.875 17.5578 24.1828 17.25 24.5625 17.25H25.9375C26.3172 17.25 26.625 17.5578 26.625 17.9375V19.3125C26.625 19.6922 26.3172 20 25.9375 20H24.5625C24.1828 20 23.875 19.6922 23.875 19.3125V17.9375Z",
    fill: "#E1CE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 17.25C28.3078 17.25 28 17.5578 28 17.9375V19.3125C28 19.6922 28.3078 20 28.6875 20H30.0625C30.4422 20 30.75 19.6922 30.75 19.3125V17.9375C30.75 17.5578 30.4422 17.25 30.0625 17.25H28.6875Z",
    fill: "#E1CE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 22.0625C19.75 21.6828 20.0578 21.375 20.4375 21.375H21.8125C22.1922 21.375 22.5 21.6828 22.5 22.0625V23.4375C22.5 23.8172 22.1922 24.125 21.8125 24.125H20.4375C20.0578 24.125 19.75 23.8172 19.75 23.4375V22.0625Z",
    fill: "#E1CE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5625 21.375C24.1828 21.375 23.875 21.6828 23.875 22.0625V23.4375C23.875 23.8172 24.1828 24.125 24.5625 24.125H25.9375C26.3172 24.125 26.625 23.8172 26.625 23.4375V22.0625C26.625 21.6828 26.3172 21.375 25.9375 21.375H24.5625Z",
    fill: "#E1CE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22.0625C28 21.6828 28.3078 21.375 28.6875 21.375H30.0625C30.4422 21.375 30.75 21.6828 30.75 22.0625V23.4375C30.75 23.8172 30.4422 24.125 30.0625 24.125H28.6875C28.3078 24.125 28 23.8172 28 23.4375V22.0625Z",
    fill: "#E1CE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 25.5C20.0578 25.5 19.75 25.8078 19.75 26.1875V27.5625C19.75 27.9422 20.0578 28.25 20.4375 28.25H21.8125C22.1922 28.25 22.5 27.9422 22.5 27.5625V26.1875C22.5 25.8078 22.1922 25.5 21.8125 25.5H20.4375Z",
    fill: "#E1CE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.875 26.1875C23.875 25.8078 24.1828 25.5 24.5625 25.5H25.9375C26.3172 25.5 26.625 25.8078 26.625 26.1875V27.5625C26.625 27.9422 26.3172 28.25 25.9375 28.25H24.5625C24.1828 28.25 23.875 27.9422 23.875 27.5625V26.1875Z",
    fill: "#E1CE00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 25.5C28.3078 25.5 28 25.8078 28 26.1875V27.5625C28 27.9422 28.3078 28.25 28.6875 28.25H30.0625C30.4422 28.25 30.75 27.9422 30.75 27.5625V26.1875C30.75 25.8078 30.4422 25.5 30.0625 25.5H28.6875Z",
    fill: "#E1CE00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.875C17 15.1156 17.6156 14.5 18.375 14.5H32.125C32.8844 14.5 33.5 15.1156 33.5 15.875V35.125C33.5 35.8844 32.8844 36.5 32.125 36.5H18.375C17.6156 36.5 17 35.8844 17 35.125V15.875ZM32.125 15.875L18.375 15.875V35.125H22.5V31.6875C22.5 31.3078 22.8078 31 23.1875 31H27.3125C27.6922 31 28 31.3078 28 31.6875V35.125H32.125V15.875Z",
    fill: "#E1CE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTadaLink);
export default __webpack_public_path__ + "static/media/tada-link.bfbe9b34a1f2f252b8c600b73bd0f366.svg";
export { ForwardRef as ReactComponent };